<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">账户审核-试客<span>{{userName}}</span></span>
      </div>
      <div v-if="plateformInfo.statusStr == '未审核'">
        <el-button type="primary" plain size="mini" @click.native="reviewStatus(true)">审核通过</el-button>
        <el-button type="danger" plain size="mini" @click.native="reviewStatus(false)">审核不通过</el-button>
      </div>
      <div v-else>
        <span>状态：<span>{{plateformInfo.statusStr}}</span></span>
        <div v-if="plateformInfo.statusStr != '审核通过'">
          <span>原因：<span>{{plateformInfo.because}}</span></span>
          <div><span style="color: red">修改审核状态为：</span>
            <el-button type="primary" plain size="mini" @click="reviewStatus(true)">审核通过</el-button>
          </div>
        </div>
        <div v-else>
          <span>修改审核状态为：
            <el-button type="primary" plain size="mini" @click="reviewStatus(false)" >审核不通过</el-button>
          </span>
        </div>
      </div>
      <div class="tableCls" style="margin-top: 15px;">
        <el-row>
          <el-col :span="24">
            <div style="background-color: #44b1eb; width: 100%;line-height: 33px;">
              账号信息
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="subLine leftline" style="width: 100%;">
              <span style="padding-left: 5%;">会员名：<span>{{plateformInfo.plateformUsername}}</span></span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="subLine" style="width: 100%">
              <span style="padding-left: 5%;">平台：<span>{{plateformInfo.plateformName}}</span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="subLine leftline" style="width: 100%;">
              <span style="padding-left: 5%;">性别：<span>{{plateformInfo.plateformSex?"男":"女"}}</span></span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="subLine" style="width: 100%">
              <span style="padding-left: 5%;">年龄：<span>{{plateformInfo.plateformAge}}</span></span>
            </div>
          </el-col>
        </el-row>
        <el-row v-show="plateformInfo.plateformName == '淘宝'">
          <el-col :span="12">
            <div class="subLine leftline" style="width: 100%;">
              <span style="padding-left: 5%;">淘气值：<span>{{plateformInfo.taoValue}}</span></span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="subLine" style="width: 100%">
              <span style="padding-left: 5%;">钻级：<span>{{plateformInfo.diamondsLevel}}</span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="subLine leftline" style="width: 100%;">
              <span style="padding-left: 5%;">地址：<span>{{plateformInfo.plateformAddress}}</span></span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="subLine" style="width: 100%">
              <span style="padding-left: 5%;">花呗：<span>{{plateformInfo.aliyunPay?"已开通":"未开通"}}</span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="subLine leftline" style="width: 100%;">
              <span style="padding-left: 5%;"><span style="color: red">{{plateformInfo.grifterString}}</span></span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="subLine" style="width: 100%">
              <span style="padding-left: 5%;"><span></span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="subLine leftline" style="width: 100%;">
              <span style="padding-left: 5%;">
                降权商家数量：<span style="color: red;padding-right: 1%;">0</span>
                获取时间：<span>2021/9/4</span>
                <span style="padding-left: 1%;">
                <el-button size="small" type="text">重新获取</el-button>
                <el-button size="small" type="text">查看详情</el-button>
                  </span>
              </span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="subLine" style="width: 100%">
              <span style="padding-left: 5%;"><span></span></span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="lineBody" style="width: 100%;">
              <span style="padding-left: 2.5%;">畅行验号结果： <span style="color: red;">未获取到验号数据</span>
                <span style="padding-left: 1%;">
                <el-button size="small" type="text">查看详情</el-button>
                <el-button size="small" type="text">智能打标</el-button>
                <el-button size="small" type="text">设置信息</el-button>
                </span>
              </span>
            </div>
          </el-col>
        </el-row>
        <div style="display: none">
        <el-row>
          <el-col :span="24">
            <div style="background-color: #44b1eb; width: 100%;line-height: 33px;">
              账号标签：<span style="margin:0 1%;">
              <el-button size="mini" plain>全选</el-button>
              <el-button size="mini" plain>反选</el-button>
            </span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="lineBody" style="width: 100%;">
              <span style="padding-left: 2.5%;">畅行验号结果： 未获取到验号数据 查看详情 智能打标 设置信息</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="lineBody" style="width: 100%;text-align: center;">
              <el-button type="primary" size="small" plain>保存标签</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div style="background-color: #44b1eb; width: 100%;line-height: 33px;">
              收藏标签：<span style="margin:0 1%;">
              <el-button size="mini" plain>全选</el-button>
              <el-button size="mini" plain>反选</el-button>
            </span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="lineBody" style="width: 100%;">
              <span style="padding-left: 2.5%;">畅行验号结果： 未获取到验号数据 查看详情 智能打标 设置信息</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="lineBody" style="width: 100%;text-align: center;">
              <el-button type="primary" size="small" plain>保存标签</el-button>
            </div>
          </el-col>
        </el-row>
        </div>
        <el-row>
          <el-col :span="24">
            <div style="background-color: #44b1eb; width: 100%;line-height: 33px;">
              截图信息
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="lineBody" style="border-bottom: 0 solid #04befe; width: 100%;">
              <span style="padding-left: 2.5%;">
                <el-image style="width: 260px; height: 260px;margin: 1%;"
                          :src="plateformInfo.imageUrl"
                          :preview-src-list="new Array(plateformInfo.imageUrl)"
                          lazy>
                </el-image>
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
        <el-form-item label="原因">
          <el-input v-model="dialogForm.because" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitStatus()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {changePlateformStatus, getPlateformAccountInfo} from "../../api/b2cbusiness/b2c_customerinfo";
import {isObjectEmpty, isStrEmpty} from "../../lib/utils";

export default {
  name: "AccountManageDetail",
  mixins: [MixinCUD],
  data() {
    return {
      userName:"",
      dialogFormVisible: false,
      dialogTitle: "审核不通过的原因",
      dialogRefName: "dialogForm",
      dialogForm:{
        accountId: "",
        status:"审核通过",
        because:"",
      },
      plateformInfo:{}
    }
  },
  mounted() {
    if (!isStrEmpty(this.$route.query) && !isObjectEmpty(this.$route.query)){
      sessionStorage.setItem('accountdetail', JSON.stringify(this.$route.query));
    }
    this.userName = JSON.parse(sessionStorage.getItem('accountdetail')).userName;
    this.getData();
  },
  methods:{
    submitStatus(){
      changePlateformStatus(this.dialogForm).then(res=>{
        if (res.success){
          this.$message.success("更新信息成功！");
          this.dialogFormVisible = false;
          this.getData();
        }
      });
    },
    reviewStatus(statusTag){
      this.dialogForm.accountId = this.plateformInfo.id;
      if (statusTag){
        this.dialogForm.status = "审核通过";
        changePlateformStatus(this.dialogForm).then(res=>{
          if (res.success){
            this.$message.success("更新信息成功！");
            this.getData();
          }
        });
      }else{
        this.dialogFormVisible = true;
        this.dialogForm.status = "审核未通过";
      }
    },
    getData(){
      getPlateformAccountInfo(JSON.parse(sessionStorage.getItem('accountdetail')).accountId).then(res=>{
        console.log(res.data)
        if (res.success){
          this.plateformInfo = res.data;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.tableCls{
  border: 1px solid #04befe;
  border-radius: 5px;
  color: #FFFFFF;
  text-align: center;

  .subLine{
    border-bottom: 1px solid #04befe;
    color: black;
    line-height: 33px;
    text-align: left;
  }

  .leftline{
    border-bottom: 1px solid #04befe;
    border-right: 1px solid #04befe;
    line-height: 33px;
    text-align: left;
  }

  .lineBody{
    border-bottom:1px solid #04befe;
    color: black;
    text-align: left;
    line-height: 33px;
  }
}


</style>
